import { render, staticRenderFns } from "./updateClose.vue?vue&type=template&id=3bb3f98b&"
import script from "./updateClose.vue?vue&type=script&lang=js&"
export * from "./updateClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports